import {Component, ReactNode, Suspense} from 'react';
import {createPortal} from 'react-dom';

import {AlertMessageProps} from 'app/core/alerts/interface';
import {LazyAlertMessage} from 'app/core/alerts/lazy';
import {FCWithChildren} from 'app/interface';

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    componentDidCatch(error: Error): void {
        this.setState({
            hasError: true,
            originalErrorMsg: error.message,
        });
    }

    private renderAlertMessage() {
        const AlertMessageComponent = this.props.AlertMessage ?? LazyAlertMessage;
        return (
            <AlertMessageComponent msg={this.props.msg} type="error" className={this.props.className}>
                {this.props.showOriginalErrorMsg && this.state.originalErrorMsg && <div className="fs-sm">{this.state.originalErrorMsg}</div>}
            </AlertMessageComponent>
        );
    }

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        if (!this.props.msg && !this.props.showOriginalErrorMsg) {
            return;
        }

        return (
            <Suspense fallback={''}>
                {this.props.portalTarget && createPortal(this.renderAlertMessage(), this.props.portalTarget)}
                {!this.props.portalTarget && this.renderAlertMessage()}
            </Suspense>
        );
    }
}

interface ErrorBoundaryProps {
    msg: string;
    AlertMessage?: FCWithChildren<AlertMessageProps>;
    className?: string;
    showOriginalErrorMsg?: boolean;
    children?: ReactNode;
    portalTarget?: HTMLElement;
}

interface ErrorBoundaryState {
    hasError: boolean;
    originalErrorMsg?: string;
}
